module.exports = __webpack_public_path__ + "img/scheme-config-active.b9c0d26d.svg";